/*
 * Copyright (c) Nexign, JSC, 2019-2020.
 */
/**
 * Common button component for DropDownFilter
 *
 * @author Evgenij Tyan
 * @author Anton Panasenko
 * @author Yakov Gushchin
 * @version 1.10.0
 * @since 1.1.0
 */

import { memo } from 'react';

import classNames from 'classnames';

import ICommonTranslationDropdown from '../../../modules/internationalization/types/common/dropdown';
import { EllipseText } from '../index';
import { SelectDropContainerStyled, SelectDropStyled } from '../Select/styled/SelectDrop';
import { DropDownFilterButtonSize } from './DropDownFilter';

export interface IDropDownFilterButtonProps {
    disabled?: boolean;
    filterButtonLabel?: string;
    filterButtonSize?: DropDownFilterButtonSize;
    icon?: string;
    iconOpened?: string;
    isToolTipShown?: boolean;
    keyDownHandler?: (event: React.KeyboardEvent) => void;
    kind?: string;
    placeholder?: string;
    selectDropRef?: React.RefObject<HTMLDivElement>;
    translation?: ICommonTranslationDropdown;
}

const DropDownFilterButtonCommon = (props: IDropDownFilterButtonProps) => {
    const classes = classNames({
        closed: !props.isToolTipShown,
        disabled: props.disabled,
        opened: props.isToolTipShown,
    })
    return (
        <SelectDropContainerStyled>
            <SelectDropStyled
                className={classes}
                icon={props.icon}
                iconOpened={props.iconOpened}
                kind={props.kind}
                ref={props.selectDropRef}
                selectDropSize={props.filterButtonSize}
                onKeyDown={props.keyDownHandler}
            >
                {
                    props.filterButtonLabel
                        ? <EllipseText title={props.filterButtonLabel}>
                            {props.filterButtonLabel}
                        </EllipseText>
                        : <span className="drop-down-filter__select-placeholder">
                        { props.placeholder ?? props.translation?.placeholder ?? ''}
                    </span>
                }
            </SelectDropStyled>
            <input/>
        </SelectDropContainerStyled>

    )
}

;

export default memo(DropDownFilterButtonCommon);
